import { NotYetBuilt } from '../shared.tsx';
import { t } from '../../messages.ts';

/**
 * Subscription plans. The API is built and inert; the screen is held at the
 * product owner's request until the Enterprise feature set is decided, so
 * this page reads nothing and says why.
 */
export function Plans() {
  return (
    <NotYetBuilt
      title={t('nav.plans')}
      what={t('plat.plans.what')}
      meanwhile={t('plat.plans.meanwhile')}
    />
  );
}
